import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/apiClient';

interface Representative {
  name: string;
  mobile?: string;
  id?: number;
}

interface Identity {
  id: number;
  name: string;
  display_name: string;
  slug: string;
  publish_status: string;
  content_status: string;
  published_applications_count: string | null;
  applications_count: string | null;
  wallets_count: string;
  sibche_address: string;
  identity_type: string;
  representatives?: Representative[];
  agents?: Representative[];
}

const fetchIdentities = async () => {
  const response = await apiClient.get('/v2/publisher/dashboard/identities');

  // Get representatives from localStorage
  const storedRepresentatives = localStorage.getItem('identity_representatives');
  const representativesMap = storedRepresentatives ? JSON.parse(storedRepresentatives) : {};

  // Merge representatives with identities
  const identities = response.data.identities.map((identity: Identity) => ({
    ...identity,
    representatives: representativesMap[identity.id] || [],
  }));

  return identities;
};

const useIdentities = (forceRefetch = false) => {
  return useQuery<Identity[], Error>({
    queryKey: ['identities'],
    queryFn: fetchIdentities,
    staleTime: 0, // داده بلافاصله stale شود
    gcTime: 5 * 60 * 1000, // 5 دقیقه
    refetchOnWindowFocus: false, // کاهش refetch های اضافی
    refetchOnMount: true,
    refetchOnReconnect: true,
    retry: 2, // کاهش تعداد retry
    retryDelay: 1000, // تاخیر بین retry ها
    initialDataUpdatedAt: forceRefetch ? Date.now() : undefined,
  });
};

export default useIdentities;
